import React from "react"
import { Container, Breadcrumb, BreadcrumbItem, Row, Col } from "reactstrap"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import Layout from "./../components/layout"
import SEO from "./../components/seo"
import "../style/partners.css"

function Partners() {
  const data = useStaticQuery(graphql`
    query {
      oracle: file(relativePath: { eq: "oracle.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      msqlserver: file(relativePath: { eq: "msqlserver.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      sybase: file(relativePath: { eq: "sybase.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mysql: file(relativePath: { eq: "mysql.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mariadb: file(relativePath: { eq: "mariadb.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      db2: file(relativePath: { eq: "db2.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      mongodb: file(relativePath: { eq: "mongodb.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      postgres: file(relativePath: { eq: "postgres.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      msazure: file(relativePath: { eq: "msazure.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      amazonws: file(relativePath: { eq: "amazonws.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      hadoop: file(relativePath: { eq: "hadoop.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      couchbase: file(relativePath: { eq: "couchbase.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ca: file(relativePath: { eq: "ca.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      hp: file(relativePath: { eq: "hp.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ibm: file(relativePath: { eq: "ibm.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      macrosoft: file(relativePath: { eq: "macrosoft.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      redhat: file(relativePath: { eq: "redhat.png" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      microfocus: file(relativePath: { eq: "microfocus.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ibmz: file(relativePath: { eq: "ibmz.png" }) {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ibmpower: file(relativePath: { eq: "ibmpower.png" }) {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      intel: file(relativePath: { eq: "intel.png" }) {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      amd: file(relativePath: { eq: "amd.png" }) {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      arm: file(relativePath: { eq: "arm.png" }) {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      sparc: file(relativePath: { eq: "sparc.png" }) {
        childImageSharp {
          fluid(maxWidth: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Layout>
      <SEO />
      <Breadcrumb className="breadCrumb">
        <BreadcrumbItem>
          <a className="breadCrumbLinks" href="/">
            Home
          </a>
        </BreadcrumbItem>
        <BreadcrumbItem active>Partners</BreadcrumbItem>
      </Breadcrumb>
      <Container className="container">
        <h1>Partners</h1>
        <Row>
          <Col className="my-auto" xs="6" md="4" xl="3">
            <a
              href="https://www.oracle.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images oracleImage"
                fluid={data.oracle.childImageSharp.fluid}
                alt="Oracle Logo"
                title="Oracle Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="6" md="4" xl="3">
            <a
              href="https://www.ibm.com/analytics/db2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images db2Image"
                fluid={data.db2.childImageSharp.fluid}
                alt="Db2 Logo"
                title="Db2 Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="6" md="4" xl="3">
            <a
              href="https://www.broadcom.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images caImage"
                fluid={data.ca.childImageSharp.fluid}
                alt="CA Technologies Logo"
                title="Broadcom Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="6" md="4" xl="3">
            <a
              href="https://www8.hp.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images hpImage"
                fluid={data.hp.childImageSharp.fluid}
                alt="hp Logo"
                title="HP Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="6" md="4" xl="3">
            <a
              href="https://www.ibm.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images ibmImage"
                fluid={data.ibm.childImageSharp.fluid}
                alt="IBM Logo"
                title="IBM Website"
              />
            </a>
          </Col>
        </Row>
        <h2 style={{ textAlign: "center", marginTop: "1em" }}>Platforms</h2>
        <Row>
          <Col className="my-auto" xs="4" md="3" xl="2">
            <a
              href="https://www.ibm.com/it-infrastructure/z"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images ibmzImage"
                fluid={data.ibmz.childImageSharp.fluid}
                alt="IBM Z Logo"
                title="IBM Z Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="4" md="3" xl="2">
            <a
              href="https://www.ibm.com/it-infrastructure/power "
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images ibmpowerImage"
                fluid={data.ibmpower.childImageSharp.fluid}
                alt="IBM Power Logo"
                title="IBM Power Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="4" md="3" xl="2">
            <a
              href="https://ark.intel.com/content/www/us/en/ark.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images intelImage"
                fluid={data.intel.childImageSharp.fluid}
                alt="Intel Logo"
                title="Intel Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="4" md="3" xl="2">
            <a
              href="https://www.amd.com/en/products/specifications"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images amdImage"
                fluid={data.amd.childImageSharp.fluid}
                alt="AMD Logo"
                title="AMD Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="4" md="3" xl="2">
            <a
              href="https://www.arm.com/products/silicon-ip-cpu"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images armImage"
                fluid={data.arm.childImageSharp.fluid}
                alt="ARM Logo"
                title="ARM Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="4" md="3" xl="2">
            <a
              href="https://www.oracle.com/servers/sparc/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images sparcImage"
                fluid={data.sparc.childImageSharp.fluid}
                alt="Oracle Sparc Logo"
                title="Oracle Sparc Website"
              />
            </a>
          </Col>
        </Row>
        <h2 style={{ textAlign: "center", marginTop: "1em" }}>
          Related Technologies
        </h2>
        <Row>
          <Col className="my-auto" xs="4" md="3" xl="2">
            <a
              href="https://www.microsoft.com/en-ca/sql-server/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images msqlserverImage"
                fluid={data.msqlserver.childImageSharp.fluid}
                alt="Microsoft SQL Server Logo"
                title="Microsoft SQL Server Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="4" md="3" xl="2">
            <a
              href="https://www.sap.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images sybaseImage"
                fluid={data.sybase.childImageSharp.fluid}
                alt="Sybase Logo"
                title="Sybase Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="4" md="3" xl="2">
            <a
              href="https://www.mysql.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images mysqlImage"
                fluid={data.mysql.childImageSharp.fluid}
                alt="My SQL Logo"
                title="My SQL Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="4" md="3" xl="2">
            <a
              href="https://mariadb.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images mariadbImage"
                fluid={data.mariadb.childImageSharp.fluid}
                alt="Maria DB Logo"
                title="Maria DB Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="4" md="3" xl="2">
            <a
              href="https://www.mongodb.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images mongodbImage"
                fluid={data.mongodb.childImageSharp.fluid}
                alt="Mongo DB Logo"
                title="Mongo DB Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="4" md="3" xl="2">
            <a
              href="https://www.postgresql.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images postgresImage"
                fluid={data.postgres.childImageSharp.fluid}
                alt="Postgres SQL Logo"
                title="Postgres Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="4" md="3" xl="2">
            <a
              href="https://azure.microsoft.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images msazureImage"
                fluid={data.msazure.childImageSharp.fluid}
                alt="Microsoft Azure Logo"
                title="Microsoft Azure Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="4" md="3" xl="2">
            <a
              href="https://aws.amazon.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images amazonwsImage"
                fluid={data.amazonws.childImageSharp.fluid}
                alt="Amazon Web Services Logo"
                title="Amazon Web Services Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="4" md="3" xl="2">
            <a
              href="https://hadoop.apache.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images amazonwsImage"
                fluid={data.hadoop.childImageSharp.fluid}
                alt="Hadoop Logo"
                title="Hadoop Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="4" md="3" xl="2">
            <a
              href="https://www.couchbase.com/ "
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images couchbaseImage"
                fluid={data.couchbase.childImageSharp.fluid}
                alt="Couchbase Logo"
                title="Couchbase Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="4" md="3" xl="2">
            <a
              href="https://www.macrosoftinc.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images macrosoftImage"
                fluid={data.macrosoft.childImageSharp.fluid}
                alt="Macrosoft Logo"
                title="Macrosoft Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="4" md="3" xl="2">
            <a
              href="https://connect.redhat.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images redhatImage"
                fluid={data.redhat.childImageSharp.fluid}
                alt="Red Hat Logo"
                title="Red Hat Website"
              />
            </a>
          </Col>
          <Col className="my-auto" xs="4" md="3" xl="2">
            <a
              href="https://www.microfocus.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Img
                className="partners-images microfocusImage"
                fluid={data.microfocus.childImageSharp.fluid}
                alt="Microfocus Logo"
                title="Microfocus Website"
              />
            </a>
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default Partners
